<template>
  <div class="dimension page-box">
    <div class="page-content">
      <div class="content-header">
        <vs-button
          class="search-btn btn box-item"
          @click="searchHandle"
        >刷新</vs-button>
        <vs-button
          style="margin-left: 10px"
          class="search-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              维度名称
            </vs-th>
            <vs-th>
              备注
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.dimensionName}}
              </vs-td>
              <vs-td>
                {{tr.remark || '-'}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-dialog
      :dialog-show="dialogShow"
      @close="closeAddDialog"
      @add-success="addSuccess"
    ></add-dialog>
  </div>
</template>

<script>
import addDialog from "../../../../../components/sys/dataPermission/dimension-list/addDialog";
import initData from "@/mixins/initData";
export default {
  name: "index",
  components: {
    addDialog,
  },
  mixins: [initData],
  data() {
    return {
      dialogShow: false
    }
  },
  created(){
    this.init();
  },
  methods: {
    beforeInit(){
      this.url = '/wx/sys/dataPermissionDimension/list';
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'id',
        order: 'desc',
      }
      return true;
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    addHandle(){
      setTimeout(() => {
        this.dialogShow = true;
      },200);
    },
    closeAddDialog(){
      this.dialogShow = false;
    },
    addSuccess(){
      this.dialogShow = false;
      this.searchHandle();
    },
  },
}
</script>

<style lang="scss" scoped>
.dimension {
  .vs-table-outer {
    .vs-con-table {
    }
  }
 .content-header {
    padding-left: 0px;
    padding-bottom: 20px;
  }
}
</style>
